<template>
  <vs-row>
    <vs-col>
      <vs-row>
        <vs-col>
          <div class="vx-card__title mb-6"><h4 class="">{{ $t('dashboard.block.referrals_stats.title') }}</h4></div>
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-w="4">
          <dashboard-statistic :value="referralsStatsResource.lastNinetyDaysCount" :label="$t('dashboard.block.referrals_stats.indicators.last_90_days')"></dashboard-statistic>
        </vs-col>

        <vs-col vs-w="4">
          <dashboard-statistic :value="referralsStatsResource.activeReferralsCount" :label="$t('dashboard.block.referrals_stats.indicators.actives')"></dashboard-statistic>
        </vs-col>

        <vs-col vs-w="4">
          <dashboard-statistic :value="referralsStatsResource.unclaimedReferralsCount" :label="$t('dashboard.block.referrals_stats.indicators.not_yet_accepted_after_90_days')"></dashboard-statistic>
        </vs-col>
      </vs-row>
    </vs-col>
  </vs-row>
</template>

<script>
import DashboardStatistic from '@/views/app/dashboard-statistic';
import {ResourceImpl} from 'hal-client';

export default {
  name: 'dashboard-referral-stats',
  components: {DashboardStatistic},
  props: {
    referralsStatsResource: ResourceImpl
  }
};
</script>

<style scoped>

</style>
